const state = {
  locations: [], 
  routedLocation: ''
};

const mutations = {
  ADD_LOCATION(state, location){
    state.locations.push(location)
  }, 
  DELETE_LOCATION_BY_ID(state, locationId){
    for(var i = 0; i < state.locations.length; i++){
      if(state.locations[i].id == locationId){
        state.locations.splice(i, 1);
      }
    }
  }, 
  UPDATE_LOCATION(state, location){
    for(var i = 0; i < state.locations.length; i++){
      if(state.locations[i].id == location.id){
        state.locations[i] = location;
      }
    }
  }, 
  SET_ROUTED_LOCATION(state, location){
    state.routedLocation = location;
  }, 
  CLEAR_ROUTED_LOCATION(state, location){
    state.routedLocation = '';
  }
}

const getters = {
  getLocations: (state) => {
    return state.locations
  }
}

const actions = {
  async deleteLocationById({commit, rootState}, locationId){
    let locationsRef = rootState.db.collection('locations');
    await locationsRef.doc(locationId).delete();

    commit('DELETE_LOCATION_BY_ID', locationId);
  },
  async addLocation({commit, rootState}, location) {
    var locationToAdd = {
      id: location.id,
      title: location.name ? location.name : location.title,
      address: location.address, 
      latlng: {
        lat: location.latLng.lat(), 
        lng: location.latLng.lng()
      }, 
      owner: rootState.users.currentUser, 
      type: location.type, 
      event: location.event
    };

    let locationsRef = rootState.db.collection('locations');
    await locationsRef.doc(locationToAdd.id).set(locationToAdd)
      .then(function(docRef){
        commit('ADD_LOCATION', locationToAdd);
      })
  }, 
  async updateLocation({commit, rootState}, update) {
    // Update is an object that contains the location, plus any changes. 
    // Will just change update the object inplace by replacing it
    var newObject = {}
    for(let key in update){
      if(key == 'latLng'){
        newObject[key] = {
          lat: update[key]['lat'],
          lng: update[key]['lng'],
        };
      } else {
        newObject[key] = update[key];
      }
    }
    // console.log(newObject)

    let locationsRef = rootState.db.collection('locations')
    await locationsRef.doc(update.id).set(newObject)

    commit('UPDATE_LOCATION', newObject)
  },
  async getLocations({commit, rootState}){
    let locationsRef = rootState.db.collection('locations').where('owner', '==', rootState.users.currentUser);
    let locations = await locationsRef.get()

    locations.forEach((loc) => {
      var locData = loc.data()
      commit('ADD_LOCATION', {...locData, id: loc.id})
    })

  }, 
  async getLocationById({commit, rootState}, id){
    var foundLocation = state.locations.find(location => location.id == id)
    if(foundLocation){
      commit('SET_ROUTED_LOCATION', foundLocation);
    } else{
      let locationsRef = rootState.db.collection('locations').doc(id);
      const location = await locationsRef.get()
      commit('SET_ROUTED_LOCATION', location.data())
    }
  },
  clearCurrentLocation({commit, rootState}){
    commit('CLEAR_ROUTED_LOCATION');
  }
}

export default {
  namespaced: true, state, mutations, getters, actions
}